import { useEffect } from 'react'
import { Link } from 'react-router-dom'

/**
 * Where the delete-account flow lands (PRIV-001).
 *
 * The session is already gone by the time this renders, so it is a public
 * route. It exists to say the three things somebody needs at that moment: it
 * worked, here is how long you have, and here is how to undo it — rather than
 * dropping them on a sign-in form that now rejects them.
 */
export default function AccountDeleted() {
  useEffect(() => {
    document.title = 'Account scheduled for deletion — Sonologue'
  }, [])

  return (
    <div className="card card-pad">
      <div className="empty-state">
        <h1 className="title-2">Your account is on its way out</h1>
        <p>
          You have been signed out everywhere and your account is no longer visible to anybody.
          Nothing is erased for fourteen days.
        </p>
        <p className="footnote">
          Two emails are on their way: a link to download a copy of everything you wrote, and a
          link that brings the account back if you change your mind.
        </p>
        <Link className="btn btn-quiet" to="/legal/privacy">
          What happens next
        </Link>
      </div>
    </div>
  )
}
